import {
    AnimationBaseController,
    GameApiBase,
    IAnimationControllerConfiguration,
    Inject,
    Key,
    SoundType
} from "@denishussar/html5-game-engine";
import {SoundConstants, SoundLevels} from "../Constants/SoundConstants";
import { GameModel } from "../Models/GameModel";
import { Rectangle, Text } from 'pixi.js';


export interface IButtonControllerOptions {
    onClick: () => void;
    hotKey: string;
}

export class ButtonController extends AnimationBaseController {
    $model: GameModel;
    private _pointerDown: boolean = false;
    private _pointerOver: boolean = false;
    private _pressed: boolean = false;
    private _enabled: boolean = true;

    public selected = false;

    public constructor(@Inject private _options: IButtonControllerOptions,
                       @Inject private _arenaApi: GameApiBase) {
        super("ButtonController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        let keyboard = null;

        if (this._options.hotKey) {
            keyboard = {
                [Key[this._options.hotKey]]: {
                    pressed: () => {
                        if (!this._enabled) {
                            return;
                        }
                        this._pressed = true;
                        this.gotoAndStop("down");
                        setTimeout(this._options.onClick.bind(this), 10);
                    },
                    released: () => {
                        if (!this._enabled || !this._pressed) {
                            return;
                        }
                        this._pressed = false;
                        this.gotoAndStop("up");
                    },
                    down: () => {
                    },
                }
            }
        }

        return <IAnimationControllerConfiguration>{
            childControllers: {},
            sounds:[
                {
                    id: SoundConstants.BUTTON_CLICK,
                    type: SoundType.SFX
                }
            ],
            onPointerDown: () => {
                if (!this._enabled) {
                    return;
                }
                this._pointerDown = true;
                this.soundManager.playSound(SoundConstants.BUTTON_CLICK, 0, SoundLevels.UI_ACTION);
                this.gotoAndStop("down");
                setTimeout(this._options.onClick.bind(this), 40);
            },
            onPointerOut: () => {
                if (!this._enabled) {
                    return;
                }
                if (!this._pointerDown) {
                    this.gotoAndStop(this.selected ? "down" : "up");
                }
                this._pointerOver = false;
            },
            onPointerOver: () => {
                if (!this._enabled) {
                    return;
                }
                if (this._pointerDown) {
                    this.gotoAndStop("down");
                } else {
                    this.gotoAndStop(this.selected ? "down" : "over");
                }
                this._pointerOver = true;
                // this.soundManager.play(SoundConstants.BUTTON_ROLLOVER);
            },
            onPointerUp: () => {
                if (!this._enabled) {
                    return;
                }
                this._pointerDown = false;
                /*
                if (this._pointerOver) {
                    this.gotoAndStop(this.selected ? "down" : "over");

                } else {
                 */
                this.gotoAndStop(this.selected ? "down" : "up");
                //}
                // this.soundManager.play(SoundConstants.BUTTON_CLICK);
            },
            onPointerUpOutside: () => {
                if (!this._enabled) {
                    return;
                }
                this.gotoAndStop(this.selected ? "down" : "up");
                this._pointerDown = false;
            },
            onTap: () => {
                if (!this._enabled) {
                    return;
                }
                
            },
            keyboard: keyboard
        };
    }

    public toggle(select: boolean) {
        this.selected = select;
        this.gotoAndStop(this.selected ? "down" : "up");
    }

    public disabled() {
        this._enabled = false;
        this._pressed = false;
        this._pointerDown = false;
    }

    public enabled() {
        this._enabled = true;
        this.gotoAndStop("up");
    }

    protected onInitialize(): void {
        this.gotoAndStop("over");
        this.container.hitArea = new Rectangle(-this.width/2, -this.height/2, this.width, this.height);
        this.gotoAndStop("up");
    }
}

